<template>
    <div class="order-row">
        <span class="order-row__label">
             {{ label }}:
        </span>
        <span class="order-row__data">
             {{ data }}
        </span>
        <span v-if="active" class="order-row__active"></span>
    </div>
</template>

<script>
    export default {
        props: {
            label: String,
            data: String,
            active: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .order-row {
        margin: 10px 0 10px 30px;
        display: flex;
        align-items: center;

        &__label {
            font-size: 2rem;
            font-family: Nunito-Bold, sans-serif;
            margin: 0 15px 0 0;
        }

        &__data {
            font-size: 2rem;
        }

        &__active {
            display: inline-block;
            background: $green;
            width: 20px;
            height: 20px;
            border-radius: 100%;
            margin: 0 0 0 10px;
        }
    }
</style>
